import { defineAction } from '~/prix'
import llmChatDeleteAction from './llmChatDelete.action.json' assert { type: 'json' }
import { z } from 'zod'

const llmChatDeleteDefinition = defineAction({
  ...llmChatDeleteAction,

  input: z.object({
    id: z.number(),
  }),
  output: z.object({}),
})

export default llmChatDeleteDefinition
